export default {"src":"https://fishbrain.com/_next/static/media/missouri.5dbb37fe.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};